import React from "react";

import { Switch, Route, Redirect } from "react-router";

import AboutProgram from "../features/AboutProgram/AboutProgram";
import DashboardPage from "../features/Dashboard/DashboardPage";
import { CreateErrorReport } from "../features/ErrorReport";
import InstitutionLocationsAndProgramsPage from "../features/Institutions/InstitutionLocationsAndProgramsPage";
import InstitutionsPage from "../features/Institutions/InstitutionsPage";
import IzjavaOPristupacnosti from "../features/IzjavaOPristupacnosti/IzjavaOPristupacnosti";
import ObavijestOPrivatnosti from "../features/ObavijestOPrivatnosti/ObavijestOPrivatnosti";
import RequestPage from "../features/Request/RequestPage";
import RequestInfoLayout from "../features/RequestInfo/RequestInfoLayout";
import { CreateErrorReportRoute } from "./CreateErrorReportRoute";
import { ParentAndAdminRoute } from "./ParentAndAdminRoute";
import { ParentRoute } from "./ParentRoute";
import {
  dashboard as dashboardRoute,
  institutions as institutionsRoute,
  newRequestRoute,
  newPreschoolRequestRoute,
  editRequestRoute,
  editPreschoolRequestRoute,
  requestDetailsRoute,
  preschoolRequestDetailsRoute,
  draftRequestRoute,
  draftPreschoolRequestRoute,
  requestDraftDetailsRoute,
  preschoolRequestDraftDetailsRoute,
  institutionLocationsAndProgramsRoute,
  newErrorReporRoute,
  aboutProgramRoute,
  izjavaOPristupacnostiRoute,
  obavijestOPrivatnostiRoute,
} from "./routes";
import { UnauthorizedPageRoute } from "./UnauthorizedPageRoute";

export default function Routing() {
  return (
    <Switch>
      <ParentRoute exact path={dashboardRoute()} component={DashboardPage} />
      <ParentRoute
        exact
        path={institutionsRoute()}
        component={InstitutionsPage}
      />
      <ParentRoute exact path={aboutProgramRoute()} component={AboutProgram} />
      <ParentRoute
        exact
        path={izjavaOPristupacnostiRoute()}
        component={IzjavaOPristupacnosti}
      />
      <ParentRoute
        exact
        path={obavijestOPrivatnostiRoute()}
        component={ObavijestOPrivatnosti}
      />
      <ParentRoute
        path={institutionLocationsAndProgramsRoute()}
        component={InstitutionLocationsAndProgramsPage}
      />
      <ParentAndAdminRoute
        exact
        path={newRequestRoute()}
        component={RequestPage}
      />
      {
        <ParentAndAdminRoute
          exact
          path={newPreschoolRequestRoute()}
          component={RequestPage}
        />
      }
      <ParentAndAdminRoute
        exact
        path={editRequestRoute()}
        component={RequestPage}
      />
      {
        <ParentAndAdminRoute
          exact
          path={editPreschoolRequestRoute()}
          component={RequestPage}
        />
      }

      <ParentAndAdminRoute
        exact
        path={draftRequestRoute()}
        component={RequestPage}
      />
      {
        <ParentAndAdminRoute
          exact
          path={draftPreschoolRequestRoute()}
          component={RequestPage}
        />
      }

      <ParentAndAdminRoute
        path={requestDraftDetailsRoute()}
        component={RequestInfoLayout}
      />

      {
        <ParentAndAdminRoute
          path={preschoolRequestDraftDetailsRoute()}
          component={RequestInfoLayout}
        />
      }
      <ParentAndAdminRoute
        path={requestDetailsRoute()}
        component={RequestInfoLayout}
      />
      {
        <ParentAndAdminRoute
          path={preschoolRequestDetailsRoute()}
          component={RequestInfoLayout}
        />
      }

      <CreateErrorReportRoute
        exact
        path={newErrorReporRoute()}
        component={CreateErrorReport}
      />
      {
        <ParentAndAdminRoute
          path={preschoolRequestDetailsRoute()}
          component={RequestInfoLayout}
        />
      }

      <Route exact path="/">
        <Redirect to={dashboardRoute()} />
      </Route>

      <UnauthorizedPageRoute />
    </Switch>
  );
}
